<script setup>
import { ref } from 'vue'    
import { Link } from '@inertiajs/inertia-vue3'

const props = defineProps(['item','level'])
console.log('treeitem',props.item)
const childsCount = props.item.children.length
const open = ref(Array(childsCount).fill(false))
console.log('pantalla ancho',window.innerWidth)
if (window.innerWidth<800) {
    open.value = Array(childsCount).fill(false)
}else{
    if(props.level<5){
    open.value = Array(childsCount).fill(true)
    }
}
const activeChild = ref(null)
console.log(open);
const getWidth = (childs)=>{
    let count = childs.length
    let minw = 50
    let width = 100/count

    if(count>=4){
        width = 100
    }

    return width+'%'
}

const toggleItem = (index)=>{
    if(open.value[index]==false){
        open.value = Array(childsCount).fill(false)
    }
    open.value[index] = !open.value[index]
    activeChild.value = index
}
</script>

<template lang="">
    <img src="/images/arrow_down.png" class="desk-arrow" v-if="childsCount>1" style="margin:1px auto;width:20px;" alt="">   
    <hr v-if="childsCount>1 && childsCount<4" class="desk-arrow" :style="{width:(100-(100/childsCount))+'%'}" style="margin:auto;border-color:rgba(63, 63, 63, 0.5);border-width:1px;">
    <div v-if="item.children!=null" class="levelcont" :class="{'unactive':index!=activeChild && activeChild!=null}" v-for="(child,index) in item.children" :style="{width: getWidth(item.children)}" :data-parent="item.id" >
        <img src="/images/arrow_down.png" class="desk-arrow" v-if="childsCount<4" style="margin:1px auto;width:20px;" alt="">
        <img src="/images/arrow_down.png" class="mob-arrow" v-if="index==0" style="margin:1px auto;width:20px;" alt="">
        <div class="">
            <div class="classification" v-on:click='toggleItem(index)' :class="[{'principal':child.principal},child.type]" :data-parent="child.id" :data-childs="child.children.length" href="#">{{child.name}}</div>
            <Link :href="'/classification/'+child.id+'/fruits'" class="classification-link" v-if='open[index] || child.children.length==0'>Ver Clasificación</Link>
        </div>
        <span class='more-classification' v-if='!open[index] && child.children.length>0' v-on:click='toggleItem(index)'>{{child.children.length}} Más</span>
        <transition name="classification-childs">
            <div v-if='open[index]'>
                <TreeItem v-if="child.children!=null" :item='child' :level='level+1' />
            </div>
        </transition>
    </div>
</template>

<style>
    .classification-childs-enter-active {
        animation: finished 0.5s reverse;
    }
    .classification-childs-leave-active {
        animation: finished 0.5s;
    }
    @keyframes finished {
        0% { opacity: 1;}
        100% { opacity: 0;}
    }
</style>

